import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import moment from '../../../lib/moment.js'
import { Input } from 'reactstrap'
import SearchIcon from "../../../static/images/search_icon.svg"
import { DateHeader } from '../helpers/header'
import { DateHeaderMobile } from '../helpers/header-mobile-approval'
import metrolendarHelper from '../../timesheet/helpers/date'

export const TimesheetApproval = class extends React.Component {
  state={ tempSearch: '' }

  render() {
    const { handleSearch,
      openInfo,
      openRemark,
      openLegends,
    } = this.props
    const selectedDate = get(this.props, 'selectedDate')
    const weekdates = get(this.props, 'weekdates')
    const month = get(this.props, 'timesheetRequest.timesheetRequest.timesheet_snapshot.month')
    const dates = metrolendarHelper.getTableDates(moment(month), 'month')
    const week = metrolendarHelper.getTableWeekDates(moment(month), 'month')
    const date = find(weekdates, (time) => {
      const d1 = moment(selectedDate).format('YYYY-MM-DD')
      const d2 = moment(time).format('YYYY-MM-DD')
      if (d1 === d2) return moment(date).format('YYYY-MM-DD')
      return null
    })

    return (
      <Wrapper>
        <SearchField
          placeholder='Search by project'
          onChange={ (e) => {
            if (e.target.value === '') handleSearch('')
            this.setState({ tempSearch: e.target.value })
          } }
          onKeyDown={ (e) => {
            if (e.keyCode === 13) handleSearch(this.state.tempSearch)
          } }
        />
        <DateHeader dates={ dates } />
        {/* header timesheet mobile */}
        <DateHeaderMobile
          dates={ dates }
          month={ month }
          openInfo={ openInfo }
          openRemark={ openRemark }
          openLegends={ openLegends }
          weekdates={ (selectedDate.isSame(moment(), 'day') && selectedDate.isSame(moment(), 'month')) ? week : weekdates }
        />
        {/* header timesheet mobile */}
      </Wrapper>
    )
  }
}

TimesheetApproval.propTypes = {
  handleSearch: PropTypes.func,
  openInfo: PropTypes.func,
  openRemark: PropTypes.func,
  openLegends: PropTypes.func,
}
TimesheetApproval.defaultProps = {
  handleSearch: () => {},
  openInfo: () => {},
  openRemark: () => {},
  openLegends: () => {},
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const SearchField = styled(Input)`
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
  height: 30px;
  width: 30%;
  padding-left: 30px
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: 'Gotham' !important;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 1% !important;
  margin-right: 1% !important;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`




// WEBPACK FOOTER //
// ./src/components/timesheet/search-bar/timesheet-approval.js